import { prepareMessages } from '@creditinfo-ui/messages/node';

export const m = prepareMessages('toasts', [['readMore', 'Read More']]);
